var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vx-row match-height"},[_c('div',{staticClass:"vx-col w-full"},[_c('vx-card',[_c('vs-tabs',{attrs:{"vs-alignment":"fixed","alignment":"fixed"}},[(_vm.reportsTab)?_c('vs-tab',{staticClass:"mt-2",attrs:{"label":_vm.$t('Reports')}},[_c('reports')],1):_vm._e(),(
            _vm.$tabHasPermission(
              'GetExcelOfSaleAgentOrderForReportOfSamanehJame'
            )
          )?_c('vs-tab',{staticClass:"mt-2",attrs:{"label":_vm.$t('ReportComprehensiveTaxSystemForAgents')}},[_c('report-comprehensive-tax-system-agents')],1):_vm._e(),(
            _vm.$tabHasPermission(
              'GetExcelOfBusinessToCustomerOrderForReportOfSamanehJame'
            )
          )?_c('vs-tab',{staticClass:"mt-2",attrs:{"label":_vm.$t('ReportComprehensiveTaxSystemForCustomers')}},[_c('report-comprehensive-tax-system-customers')],1):_vm._e()],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }